import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const TITLE_MAP: Record<string, string> = {
  "/dash": "Dashboard Mixtape®",
  "/radio": "Mixtape Radio® – ONLINE",
  "/ajustes": "Ajustes – Mixtape Radio®",
  "/library": "Listas, Artistas, Álbumes y Podcast",
  "/news": "Novedades – Mixtape Radio®",
  "/notificaciones": "Notificaciones – Mixtape Radio®",
  "/offline": "Música sin conexión – Mixtape Radio®",
  "/go": "Ali Bhtty – Mixtape Radio®",
  "/djs": "DJs – Mixtape Radio®",
  "/subir": "Subir pistas – Mixtape Radio®",
  "/terms": "Términos y Condiciones – Mixtape Radio®",
  "/inscripcion": "inscripcion",
}

const DEFAULT_TITLE = "Mixtape Radio – MIX STREAMS DJ`s"

const TitleManager = () => {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname

    let title = DEFAULT_TITLE

    if (path.startsWith("/radio")) {
      title = "Mixtape Radio® – ONLINE"
    } else {
      title = TITLE_MAP[path] || DEFAULT_TITLE
    }

    document.title = title
  }, [location.pathname])


  /* useEffect(() => {
    const title = TITLE_MAP[location.pathname] || DEFAULT_TITLE
    document.title = title
  }, [location.pathname]) */

  return null
}

export default TitleManager